import styled from 'styled-components';
import { Box, TableBody } from '@mui/material';
import { Padding } from '@mui/icons-material';
import { ReactSortable } from 'react-sortablejs';

export const StyledTableBody = styled(TableBody)({
  tr: {
    borderBottom: '1px solid #eee'
  },
  td: {
    padding: '5px 10px',
    borderBottom: 'none',
    borderLeft: '1px solid #eee'
  }
});

export const TitleWrapper = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '80px 95px 150px 150px  150px 200px',
  div: {
    outline: '1px solid #e7e7e7',
    padding: '5px 10px'
  }
});

export const StyledBody = styled(ReactSortable)({
  display: 'grid',
  gridTemplateColumns: '1fr',
});

export const EachWrapper = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '80px 95px 150px 150px  150px 200px',

  div: {
    outline: '1px solid #e7e7e7',
    padding: '5px 10px'
  }
});

export const Actions = styled(Box)({
  display: 'flex',
  gap: '10px'
});

export const Wrapper = styled(Box)({
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-start',
});
